import api, { checkTokenErrorResponse } from '..';

const moedaTypes = [
    [0, 'BRL'],
    [1, 'USD']
];

const regimes_tributarios = [
    [1, "Simples Nacional"],
];

// const siglas_estados = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

const siglas_estados = [
    'AC - Acre',
    'AL - Alagoas',
    'AP - Amapá',
    'AM - Amazonas',
    'BA - Bahia',
    'CE - Ceará',
    'DF - Distrito Federal',
    'ES - Espírito Santo',
    'GO - Goiás',
    'MA - Maranhão',
    'MT - Mato Grosso',
    'MS - Mato Grosso do Sul',
    'MG - Minas Gerais',
    'PA - Pará',
    'PB - Paraíba',
    'PR - Paraná',
    'PE - Pernambuco',
    'PI - Piauí',
    'RJ - Rio de Janeiro',
    'RN - Rio Grande do Norte',
    'RS - Rio Grande do Sul',
    'RO - Rondônia',
    'RR - Roraima',
    'SC - Santa Catarina',
    'SP - São Paulo',
    'SE - Sergipe',
    'TO - Tocantins'
];

export async function getCompanies() {
    return api.get("empresas/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postCompany(
    nome,
    nome_fantasia,
    razao_social,
    email,
    enviar_email_destinatario,
    telefone,
    ddi,
    iso2_ddi,
    discrimina_impostos,
    logradouro,
    cidade,
    estado,
    bairro,
    numero,
    cep,
    cnpj,
    inscricao_estadual,
    inscricao_municipal,
    regime_tributario,
    habilita_nfe,
    habilita_nfce,
    habilita_nfse,
    csc_nfce_producao,
    id_token_nfce_producao,
    arquivo_certificado_base64 = null,
    senha_certificado,
    nota_fiscal,
    moeda,
    dry_run = 0
) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("nome_fantasia", nome_fantasia);
    formdata.append("razao_social", razao_social);
    formdata.append("email", email);
    formdata.append("enviar_email_destinatario", enviar_email_destinatario ? 'true' : 'false');
    formdata.append("discrimina_impostos", discrimina_impostos ? 'true' : 'false');
    if(telefone)
        formdata.append("telefone", telefone);
    if(ddi)
        formdata.append("ddi", ddi);
    if(iso2_ddi)
        formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("logradouro", logradouro);
    formdata.append("bairro", bairro);
    formdata.append("numero", numero);
    formdata.append("estado", estado);
    formdata.append("cidade", cidade);
    formdata.append("cep", cep);
    formdata.append("cnpj", cnpj);
    formdata.append("inscricao_estadual", inscricao_estadual);
    formdata.append("inscricao_municipal", inscricao_municipal);
    formdata.append("regime_tributario", regime_tributario);
    formdata.append("habilita_nfe", habilita_nfe ? 'true' : 'false');
    formdata.append("habilita_nfce", habilita_nfce ? 'true' : 'false');
    formdata.append("habilita_nfse", habilita_nfse ? 'true' : 'false');
    formdata.append("csc_nfce_producao", csc_nfce_producao);
    formdata.append("id_token_nfce_producao", id_token_nfce_producao);
    if(arquivo_certificado_base64 && arquivo_certificado_base64 instanceof File)
        formdata.append("arquivo_certificado_base64", arquivo_certificado_base64);
    formdata.append("senha_certificado", senha_certificado);
    formdata.append("nota_fiscal", nota_fiscal ? 'true': 'false');
    formdata.append("moeda", moeda);


    return api.post(`empresas/`, formdata, {
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getCompany(id) {
    return api.get(`empresas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteCompany(id) {
    return api.delete(`empresas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function patchCompany(
    id,
    nome,
    nome_fantasia,
    razao_social,
    email,
    enviar_email_destinatario,
    telefone,
    ddi,
    iso2_ddi,
    discrimina_impostos,
    logradouro,
    cidade,
    estado,
    bairro,
    numero,
    cep,
    cnpj,
    inscricao_estadual,
    inscricao_municipal,
    regime_tributario,
    habilita_nfe,
    habilita_nfce,
    habilita_nfse,
    csc_nfce_producao,
    id_token_nfce_producao,
    arquivo_certificado_base64 = null,
    senha_certificado,
    nota_fiscal,
    moeda
) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("nome_fantasia", nome_fantasia);
    formdata.append("razao_social", razao_social);
    formdata.append("email", email);
    formdata.append("enviar_email_destinatario", enviar_email_destinatario ? 'true' : 'false');
    formdata.append("discrimina_impostos", discrimina_impostos ? 'true' : 'false');
    if(telefone)
        formdata.append("telefone", telefone);
    if(ddi)
        formdata.append("ddi", ddi);
    if(iso2_ddi)
        formdata.append("iso2_ddi", iso2_ddi);;
    formdata.append("logradouro", logradouro);
    formdata.append("bairro", bairro);
    formdata.append("numero", numero);
    formdata.append("estado", estado);
    formdata.append("cidade", cidade);
    formdata.append("cep", cep);
    formdata.append("cnpj", cnpj);
    formdata.append("inscricao_estadual", inscricao_estadual);
    formdata.append("inscricao_municipal", inscricao_municipal);
    formdata.append("regime_tributario", regime_tributario);
    formdata.append("habilita_nfe", habilita_nfe ? 'true' : 'false');
    formdata.append("habilita_nfce", habilita_nfce ? 'true' : 'false');
    formdata.append("habilita_nfse", habilita_nfse ? 'true' : 'false');
    formdata.append("csc_nfce_producao", csc_nfce_producao);
    formdata.append("id_token_nfce_producao", id_token_nfce_producao);
    //console.log(arquivo_certificado_base64);
    if(arquivo_certificado_base64 && arquivo_certificado_base64 instanceof File)
        formdata.append("arquivo_certificado_base64", arquivo_certificado_base64);
    formdata.append("senha_certificado", senha_certificado);
    formdata.append("nota_fiscal", nota_fiscal ? 'true': 'false');

    formdata.append("moeda", moeda);

    return api.patch(`empresas/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postLinkCompanyBankAccount(companyId, bankAccountId) {
    return api.post(`empresas/${companyId}/vincular_conta_bancaria/${bankAccountId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postLinkCompanyBankAccounts(companyId, bankAccountIds) {
    return api.post(`empresas/${companyId}/vincular_contas_bancarias/`, {
        ids: bankAccountIds
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteLinkCompanyBankAccount(companyId, bankAccountId) {
    return api.delete(`empresas/${companyId}/desvincular_conta_bancaria/${bankAccountId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getCompanyBills(id, parceiros, inicio, fim) {
    return api.post(`empresas/${id}/contas/`,
        { parceiros },
        {
            params: {
                inicio,
                fim
            }
        })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};




const companyServices = {
    getCompanies,
    getCompany,
    postCompany,
    deleteCompany,
    patchCompany,
    postLinkCompanyBankAccount,
    postLinkCompanyBankAccounts,
    deleteLinkCompanyBankAccount,
    getCompanyBills,
    moedaTypes,
    regimes_tributarios,
    siglas_estados
}
export default companyServices;